<script setup lang="ts">
withDefaults(
  defineProps<{
    color?: string;
    size?: string;
  }>(),
  {
    color: 'text-emerald-600',
    size: 'w-[30px] h-[30px]',
  },
);
</script>
<template>
  <ui-icon name="LoaderCircle" :class="[color]" class="animate-spin" />
</template>
